export const COMPANY_SUMMARY_ITEM = {
  label: 'Company Name',
  accessor: 'name',
};
